/* src/modules/discounts/reducers.js */

import { combineReducers } from 'redux';
import { keyBy } from 'lodash';

import {
  fetchDiscountHoldersTypes,
  fetchSeasonsTypes,
  createSeasonTypes,
  createDiscountHolderTypes,
  modifyDiscountHolderTypes,
  SELECT_DISCOUNT_HOLDER,
} from './action_types';

import { makeRequestReducer } from '../../config/client';

const initialDiscountHolderState = {
  lastAdded: '',
  selected: '',
};

const main = makeRequestReducer({
  types: fetchDiscountHoldersTypes,
  name: 'discountHolders',
  initialState: initialDiscountHolderState,
  mutate: (state, res) => keyBy(res, '_id'),
  append: [
    makeRequestReducer({
      types: createDiscountHolderTypes,
      name: 'addDiscountHolder',
      mutate: (state, res) => ({ ...state.data, [res._id]: res }),
    }),
    makeRequestReducer({
      types: modifyDiscountHolderTypes,
      name: 'modifyDiscountHolder',
      mutate: (state, res) => ({ ...state.data, [res._id]: res }),
    }),
    (state, action) => {
      switch (action.type) {
        case createDiscountHolderTypes[1]:
          return { ...state, lastAdded: action.payload.addDiscountHolder._id };
        case SELECT_DISCOUNT_HOLDER:
          return { ...state, selected: action.payload };
        default:
          return state;
      }
    },
  ],
});

const initialSeasonState = {
  lastAdded: '',
};

const seasons = makeRequestReducer({
  types: fetchSeasonsTypes,
  name: 'seasons',
  initialState: initialSeasonState,
  mutate: (state, res) => keyBy(res, '_id'),
  append: [
    makeRequestReducer({
      types: createSeasonTypes,
      name: 'addSeason',
      mutate: (state, res) => ({ ...state.data, [res._id]: res }),
    }),
    (state, action) => {
      switch (action.type) {
        case createSeasonTypes[1]:
          return { ...state, lastAdded: action.payload.addSeason._id };
        default:
          return state;
      }
    },
  ],
});

export default combineReducers({
  main,
  seasons,
});



// WEBPACK FOOTER //
// ./src/modules/discounts/reducers.js